@if (!isMobileView) {
    <kendo-contextmenu [items]="menuItems" [alignToAnchor]="true"
                       [anchorAlign]="{ horizontal: 'right', vertical: 'bottom' }"
                       [popupAlign]="{ horizontal: 'left', vertical: 'top'}"
                       [collision]="{ horizontal: 'flip', vertical: 'flip'}"
                       (select)="onContextMenuSelectEvent($event)" [size]="'medium'"
                       #menu>
        <ng-template kendoMenuItemTemplate let-item="item">
            @if (item.separator) {
                <hr class="w-full"/>
            } @else {
                <span class="flex items-center">
                    <bizz-icon class="mr-2 size-3 max-w-3" [iconName]="item.iconName"></bizz-icon>
                    <p class="font-sans text-xs font-medium">{{ item.text }}</p>
                </span>
            }
        </ng-template>
    </kendo-contextmenu>
}
<kendo-actionsheet #actionsheet
                   (overlayClick)="actionsheet.toggle(false)"
                   [animation]="false"
                   cssClass="bizz-context-menu">
    <ng-template kendoActionSheetContentTemplate>
        @for (item of menuItems; track item) {
            @if(!item.disabled){
            @if (item.separator) {
                <hr class="mx-2.5 my-1.5 w-full border-t"/>
            } @else {
                <span class="flex justify-between text-default cursor-pointer" (click)="onActionSheetItemClick(item)">
                    <span class="flex items-center px-3 py-2" [ngClass]="item.cssClass">
                        <bizz-icon class="mr-4 size-5" [iconName]="item.iconName!"></bizz-icon>
                        <p class="p-0 font-sans text-base font-medium">{{ item.text }}</p>
                    </span>
                    @if (item.items != undefined && item.items.length > 0) {
                        @if (!item.expanded) {
                            <bizz-icon class="text-light size-5" iconName="caret-down"></bizz-icon>
                        } @else {
                            <bizz-icon class="text-light size-5" iconName="caret-up"></bizz-icon>
                        }
                    }
            </span>
                @if (item.expanded) {
                    <div class="pl-8">
                        @for (subItem of item.items; track subItem) {
                            <span class="flex items-center px-3 py-2 text-default" [ngClass]="subItem.cssClass"
                                  (click)="onActionSheetItemClick(subItem)">
                            <bizz-icon class="mr-4 size-5" [iconName]="subItem.iconName!"></bizz-icon>
                            <p class="p-0 font-sans text-base font-medium">{{ subItem.text }}</p>
                        </span>
                        }
                    </div>
                }
            }
        }
        }

    </ng-template>
</kendo-actionsheet>